module.exports = __webpack_public_path__ + "img/joinBG.e6eabc6e.jpg";